import Vue from "vue"
import VueRouter, { RouteConfig } from "vue-router"
import Demo from "../views/demo.vue"
import { $axios } from "@/plugins/app-axios"
import store from "../store"

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes: Array<RouteConfig> = [
  {
    path: "/demo",
    name: "Demo",
    component: Demo,
  },
  {
    path: "/",
    name: "layout",
    component: () => import("@/layout/index.vue"),
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "newsCenter",
        name: "新闻中心",
        component: () => import("@/views/newsCenter/index.vue"),
      },
      {
        path: "certificateQuery",
        name: "证书查询",
        component: () => import("@/views/certificateQuery/index.vue"),
      },
      {
        path: "certificate",
        name: "证书",
        component: () => import("@/views/certificateQuery/certificate.vue"),
      },
      {
        path: "annocement",
        name: "政策公告",
        component: () => import("@/views/annocement/index.vue"),
      },
      {
        path: "dataDownload",
        name: "资料下载",
        component: () => import("@/views/dataDownload/index.vue"),
      },
      {
        path: "newsCenter/detail/:id",
        name: "详情",
        component: () => import("@/views/InfoDetail/index.vue"),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: "/",
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})


// router.beforeEach(async (to, from, next) => {
//   // 把路由信息向父页面传送
//   if (process.env.NODE_ENV === "development") {
//     // 获取用户信息
//     try {
//       const res: any = await $axios("getCurrentUser", {}, false, true)
//       if (res.data.user) {
//         store.commit("user/setUser", { user: res.data.user })
//       } else {
//         store.commit("user/setUser", { user: {} })
//       }
//     } catch (e) {
//       store.commit("user/setUser", { user: {} })
//     }
//   }
//   store.dispatch("saveUserVisited", to)
//   next()
// })

export default router
